import React from "react";

function VisitGridEmpty(props) {
  const { children } = props;

  return <>{children}</>;
}

export default VisitGridEmpty;
